 // CONTENT BLOCKS

 var redirect = getUrlParam('redirect') || '';
 if (redirect) {
   redirect = '?redirect=' + redirect;
 }

var loginmodalhtml = `
<div id="loginmodal" class="modal" style="display:none;">
  <div class="md-content">
    <div class="inner">
      <div class="replacer w880">
        <h2 class="mb10"><img alt="Ultra Passport Login" src="${upp_assets.images.logo}" width="150"></h2>
         <div class="lbreak3 clear op50" style="position:relative; margin-bottom:45px !important"></div>
         <form action="${upp_page.login}" method="post" class="styledform loginhtml" id="login-form" novalidate="novalidate">
            <ol>
              <li class="w48 left rs100">
                <label for="loginemail">${_email}:</label>
                <input type="text" id="loginemail" name="loginemail" placeholder="" data-field="email" class="required email" aria-required="true" autocomplete="email" autofocus>
              </li>
              <li class="w48 right rs100">
                <label for="loginpassword" class="left">${_password}</label>
                <div class="password-field">
                  <input type="password" id="loginpassword" name="loginpassword" placeholder="" class=" required" aria-required="true" autocomplete="current-password">
                  <a class="toggle-password fas fa-eye" tabindex="-1"></a>
                </div>
              </li>
              <li class="left w48 rs100 mb25">
                  <button type="submit" class="btn-main ${upp_assets.buttons.primary_btn} btn-lg max100 upplogin">${_logintext} <span class="fas fa-chevron-right"></span></button>
              </li>
              <li class="w48 right rs100 oauth-providers">
                <p><a href="${upp_page.signup}${redirect}" class="textbutton mlsignup nou">${_signuptext}</a> <span class="spacer">/</span> <a href="${upp_page.lost_password}" class="textbutton nou btn-lost">${_forgot}</a></p>
              </li>
            </ol>
        </form>
        <form action="${upp_page.lost_password}" method="post" class="styledform clear forgothtml" id="lost-form" style="display:none">
        <ol>
          <li>
            <label for="lostemail">${_enteryouremail}:</label>
            <input type="text" placeholder="" name="lostemail" id="lostemail" class="required email">
          </li>
         <li class="clear w100 rs100 mb25">
            <button type="submit" id="upploginbtn" name="upploginbtn" class="btn-main ${upp_assets.buttons.primary_btn} btn-lg mr30 mb15 left">${_requestnewpass} <span class="fas fa-chevron-right"></span></button>
            <a href="${upp_page.login}" class="textbutton padt10 back2login "><span class="fas fa-chevron-left fa-sm"></span> ${_backtologin}</a>
          </li>
        </ol>
      </form>
      </div>
    </div>
  </div>
  <div class="md-bg"></div>
  <a class="md-close"><i></i><b></b></a>
</div>`;


var signupmodalhtml = `
<div id="signupmodal" class="modal" style="display:none;">
  <div class="md-content">
    <div class="inner">
      <div class="replacer w880">
      <h2 class="atitle mb20 block mb10"><span class="vcenter padr20"><img alt="Ultra Passport Signup" src="${upp_assets.images.logo}" width="150"></span><span class="vcenter"></span></h2>
      <div class="lbreak3 clear op50" style="position:relative; margin-bottom:45px !important"></div>
        <form action="" method="post" class="styledform clear" id="signup-form">
      <ol>
        <li class="w48 left rs100 clear">
          <label for="email">${_emailaddy}:</label>
          <input data-field="email" name="email" id="email" placeholder="" type="text" class="required email" autocomplete="email" autofocus>
        </li>
        <li class="w48 right rs100">
          <label for="password">${_password}:</label>
          <div class="password-field">
            <input name="password" id="password" type="password" autocomplete="new-password">
            <a class="toggle-password fas fa-eye" tabindex="-1"></a>
          </div>
        </li>
        <li class="w48 left rs100">
          <label for="firstname">${_firstname}:</label>
          <input data-field="firstname" name="firstname" id="firstname" type="text" class="required" placeholder="" autocomplete="given-name">
        </li>
        <li class="w48 right rs100">
          <label for="lastname">${_lastname}:</label>
          <input data-field="lastname" name="lastname" id="lastname" type="text" class="required" autocomplete="family-name">
        </li>
        <li class="birthday w48 left rs100 clear">
            <label for="birthday">${_birthday}:</label><input type="text" name="birthday" id="birthday" data-field="birthday" class="required date-input" autocomplete="bday">
        </li>
        <li class="gender w48 right rs100 padr30 padb30">
          <label for="gender">${_gender}:</label>
          <select name="gender" id="gender" class="required" data-field="gender" aria-required="true">
            <option value="" disabled selected>— ${_pleaseselect} —</option>
            <option value="male">${_male}</option>
            <option value="female">${_female}</option>
            <option value="other">${_other}</option>
            <option value="unknown">${_unknown}</option>
          </select>
        </li>
        <li class="w48 left rs100 clear">
          <label for="country">${_country}:</label>
          <select name="country" class="required" id="country" data-field="country" autocomplete="country">
            <option value="" disabled selected>— ${_pleaseselect} —</option><option value="AF">Afghanistan</option><option value="AX">Åland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia, Plurinational State of</option><option value="BQ">Bonaire, Sint Eustatius and Saba</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="BN">Brunei Darussalam</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo</option><option value="CD">Congo, the Democratic Republic of the</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="CI">Côte d'Ivoire</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands (Malvinas)</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="VA">Holy See (Vatican City State)</option><option value="HN">Honduras</option><option value="HK">Hong Kong</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran, Islamic Republic of</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KP">Korea, Democratic People's Republic of</option><option value="KR">Korea, Republic of</option><option value="KV">Kosovo</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Lao People's Democratic Republic</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao</option><option value="MK">Macedonia, the former Yugoslav Republic of</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia, Federated States of</option><option value="MD">Moldova, Republic of</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory, Occupied</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Réunion</option><option value="RO">Romania</option><option value="RU">Russian Federation</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena, Ascension and Tristan da Cunha</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten (Dutch part)</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syrian Arab Republic</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania, United Republic of</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VE">Venezuela, Bolivarian Republic of</option><option value="VN">Viet Nam</option><option value="VG">Virgin Islands, British</option><option value="VI">Virgin Islands, U.S.</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option>
          </select>
        </li>
        <li class="w48 rs100 right">
          <label for="homeevent">${_homeevent}:</label>
          <select name="homeevent" class="required" id="homeevent">
          <option value="" disabled selected>— ${_pleaseselect} —</option><option value="south-africa">Ultra South Africa</option><option value="miami">Ultra Miami</option><option value="mexico">Ultra Mexico</option><option value="korea">Ultra Korea</option><option value="europe">Ultra Europe</option><option value="china">Ultra China</option><option value="singapore">Ultra Singapore</option><option value="bali">Ultra Bali</option><option value="japan">Ultra Japan</option><option value="brasil">Ultra Brasil</option><option value="thailand">RTU Thailand</option><option value="buenos-aires">RTU Buenos Aires</option><option value="taiwan">RTU Taiwan</option><option value="hong-kong">RTU Hong Kong</option><option value="philippines">RTU Philippines</option><option value="india">RTU India</option><option value="peru">RTU Peru</option><option value="chile">RTU Chile</option><option value="bolivia">RTU Bolivia</option><option value="paraguay">RTU Paraguay</option><option value="puerto-rico">RTU Puerto Rico</option><option value="australia">RTU Australia</option><option value="ibiza">Resistance Ibiza</option>
          </select>
        </li>
        <li class="w100 rs100 left terms">
            <label for="accept_terms">
                <input type="checkbox" name="accept_terms" id="accept_terms" class="required" aria-required="true">
                <p>${_agreesignup}</p>
            </label>
        </li>
        <li class="w100 rs100 clear padt5 padb50">
          <div class="lbreak3 op50"></div>
          <input type="hidden" id="modlocale" name="modlocale" value="${pplang}" />
          <button type="submit" class="uppsignup btn-main btn-lg ${upp_assets.buttons.primary_btn}">${_createaccount} <span class="fas fa-chevron-right"></span></button>
          <span class="spacer">/</span>
          <a href="${upp_page.login}" class="textbutton mllogin">${_signin} <span class="fas fa-chevron-right"></span></a>
        </li>
      </ol>
      </form>
    </div>
    </div>
  </div>
  <div class="md-bg"></div>
  <a class="md-close"><i></i><b></b></a>
</div>`;

var header_html = `
<li class="upplink">
  <a href="${upp_page.dashboard}" class="dashboardbtn">
      <span class="upp-photo tiny-hide2" data-field="icon"></span>
      <span class="small-hide" data-field="firstname"></span>
  </a>
  <ul class="uppsub">
    <li class="w100">
      <a href="${upp_page.dashboard}" class="uppstatus"><span data-field="badge22">
      <div class="lbreak3 op50" style="margin-bottom:15px;"></div>
        <img src="${upp_assets.images.logo}" alt="Ultra Passport" class="upp left block">
        <span class="right block">
          <strong class="block relative statuslevel clearfix">
            <span class="uicon iblock vc" data-field="icon"></span>
            <span class="iblock vc uplevel" data-field="level"></span>
          </strong>
        </span>
      </a>
      <div class="clear mb15"></div>
      <div class="lbreak3 op50 mb5"></div>
      <a href="${upp_page.events}" class="btn-main w100 mb10 btn-lg ${upp_assets.buttons.primary_btn} mr20">${_events} <span class="fas fa-chevron-right"></span></a>
      <a href="${upp_page.updates}" class="btn-main w100 mb0 btn-lg ${upp_assets.buttons.secondary_btn} mr20">${_updates} <span class="fas fa-chevron-right"></span></a>
    </li>
    <li class="edit w100">
      <div class="clear mb20"></div>
      <div class="lbreak3 op50 mb10"></div>
      <a href="${upp_page.dashboard}" class="textbutton dashboardbtn">${_mypassport} <span class="fas fa-chevron-right"></span></a>
      <span class="spacer">/</span>
      <a href="${upp_page.login}" class="textbutton upplogout">${_signout} <span class="fas fa-chevron-right"></span></a>
    </li>
  </ul>
  </li>`;

if(_createaccountheader != '') {
  _createaccount = _createaccountheader;
}
var header_html_guest = `
  <li class="upplink signupm"><a href="${upp_page.signup}"><img width="18" alt="Ultra Passport" src="${upp_assets.images.levels.platinum.icon}" class="upp-photo"><span class="small-hide">${_myaccount}</span></a>
    <ul class="uppsub">
      <li class="w100">
        <a href="${upp_page.signup}" class="uppstatus"><span>
        <div class="lbreak3 op50" style="margin-bottom:15px;"></div>
          <img src="${upp_assets.images.logo}" alt="Ultra Passport" class="upp left block">
          <span class="right block">
            <strong class="block relative statuslevel clearfix">
            <img width="22" alt="Ultra Passport Silver Icon" src="${upp_assets.images.levels.silver.icon}" class="iblock vc mt5 mr5">
            <img width="22" alt="Ultra Passport Gold Icon" src="${upp_assets.images.levels.gold.icon}" class="iblock vc mt5 mr5">
            <img width="22" alt="Ultra Passport Platinum Icon" src="${upp_assets.images.levels.platinum.icon}" class="iblock vc mt5 mr5">
            </strong>
          </span>
        </a>
        <div class="clear mb20"></div>
        <div class="lbreak3 op50 mb10"></div>
        <a href="${upp_page.events}" class="btn-main w100 mb10 btn-lg ${upp_assets.buttons.primary_btn} mr20">${_events} <span class="fas fa-chevron-right"></span></a>
        <a href="${upp_page.updates}" class="btn-main w100 mb0 btn-lg ${upp_assets.buttons.secondary_btn} mr20">${_updates} <span class="fas fa-chevron-right"></span></a>
      </li>
      <li class="edit w100">
        <div class="clear mb20"></div>
        <div class="lbreak3 op50 mb10"></div>
          <a href="${upp_page.signup}" class="textbutton signupbtn">${_signuptext} <span class="fas fa-chevron-right"></span></a>
          <span class="spacer">/</span>
          <a href="${upp_page.login}" class="textbutton loginbtn">${_signin} <span class="fas fa-chevron-right"></span></a>
      </li>
    </ul>
  </li>`;

var loginform = `
  <form action="" method="post" class="styledform" id="login-form">
    <ol>
      <li>
        <label>Email Address</label>
        <input type="text" id="email" name="email" placeholder="" data-field="email" class="required email" autocomplete="email" autofocus>
      </li>
      <li>
        <label class="left">Password</label>
        <input type="password" id="password" name="password" placeholder="" class=" required" autocomplete="current-password">
      </li>
      <li class="left w48 rs100 mb25">
        <button type="submit" class="btn-main ${upp_assets.buttons.primary_btn} upplogin">Login <span class="fas fa-chevron-right"></span></button>
      </li>
    </ol>
  </form>`;


var footer_html = `
  <div class="ppf rel">
  <div class="left sign-in-state"><p class="mb30"><a href="${upp_page.dashboard}">${_welcome} <span data-field="firstname"></span></a></p></div>
  <div class="clear"></div>
  <a href="${upp_page.dashboard}" class="uppstatus mb30"><span data-field="badge22">
    <img src="${upp_assets.images.logo}" alt="Ultra Passport" class="upp left block">
    <span class="left padl20 block">
      <strong class="block relative statuslevel clearfix">
        <span class="uicon iblock vc" data-field="icon"></span>
        <span class="silver iblock vc uplevel " data-field="level_code"></span>
      </strong>
    </span>
  </a>
  <div class="clear mb30"></div>
  <div class="lbreak3 op50 uppubar" style="margin-bottom:10px "></div>
  <p class="fub upp-upgrade">
  <a href="${upp_page.dashboard}">
  <span class="fs11 text-uppercase">${_nextlevel}</span>
  <span class="fat fa-chevron-right"></span>
  <span class="text-uppercase fs11" data-field="level-next-name"></span>
  (<strong><span class="count" data-field="level-next-percent"></span>%</strong>)
  </a></p>
  <div class="clear"></div>
  <div class="lbreak3 op50" style="margin-bottom:34px "></div>
  <div class="progress-bar status-bar w100">
    <div class="level silver left">
      <span class="currentname active" data-field="level-current-name"></span>
      <span class="nextname active" data-field="level-next-name"></span>
      <span class="em startpoints active" data-field="level-points-start"></span>
      <span class="em endpoints active" data-field="level-points-end"></span>
      <div class="bar">
        <div class="fill" data-field="fillpercent"></div>
      </div>
    </div>
  </div>
  <div class="clear mb25"></div>
  <div class="upb clearfix hide">
    <div class="upb-back"></div>
    <div class="upb-bar">
      <div class="fill" data-field="fillpercent"></div>
    </div>
    <div class="upb-front"></div>
  </div>
  <p><a href="${upp_page.login}" class="upplogout"><span class="fas fa-left fa-2xs"></span> <span class="fs11 text-uppercase">${_signout}</span></a></p>
</div>`;


var footer_html_guest = `
  <div class="ppf">
    <p class="pphead block">
      <a href="${upp_page.login}" class="block clearfix">
        <img alt="Ultra Passport" src="${upp_assets.images.logo}" width="120" class="block left"> 
        <span class="ml20 mt5 block left">
          <strong class="iblock relative  clearfix">
            <img width="22" alt="Ultra Passport Silver Icon" src="${upp_assets.images.levels.silver.icon}" class="iblock mr5">
            <img width="22" alt="Ultra Passport Gold Icon" src="${upp_assets.images.levels.gold.icon}" class="iblock mr5">
            <img width="22" alt="Ultra Passport Platinum Icon" src="${upp_assets.images.levels.platinum.icon}" class="iblock mr5">
          </strong>
        </span>
      </a>
    </p>
    <p class="ppstart">${_starttext}</p>
    <form class="styledform validate" id="quickform" method="post" action="${upp_page.signup}">
    <button type="submit" class="btn-main btn-lg w100 ${upp_assets.buttons.primary_btn}">${_getstarted} <span class="fas fa-chevron-right"></span></button>
    </form>
  </div>`;

var almost = `
  <h1 class="title">${_almost}</h1>
  <div class="lclear op50"></div>
  <h2>${_almost2}</h2>
  <p class="almost1">${_almost3}</p>
  <p class="almost2">${_almost4}<br><br></p>
  <form action="${upp_page.dashboard}" method="post">
  <p><button class="btn-main btn-lg ${upp_assets.buttons.secondary_btn} continue uppsignup working disabled" disabled="disabled">${_almost5} <span class="fas fa-chevron-right"></span></button></p>
  </form>`;

var guestinfo = `
  <section id="guestinfo" class="inner" style="margin-bottom:50px;">
    <h1 class="atitle mb20 block mb10"><span class="vcenter padr20"><img alt="Ultra Passport" src="${upp_assets.images.logo}" width="150"></span><span class="vcenter"></span></h1>
    <div class="lbreak3 mb25"></div>
    <p>${_guestnotice}</p>
    <div class="clear padt25"></div>
    <a href="${upp_page.signup}" class="fs14 btn-main btn-lg signupbtn ${upp_assets.buttons.primary_btn}">${_signuptext} <span class="fas fa-chevron-right"></span></a>
    <span class="spacer">/</span> <a href="${upp_page.login}" class="btn-main btn-lg loginbtn ${upp_assets.buttons.outline_btn} fs14">${_logintext} <span class="fas fa-chevron-right"></span></a>
  </section>`;

var regHTML2 = `
    <div class="registered-summary clearfix clear" style="display:none">
    <div class="clear lbreak3 op50"></div>
    <ul class="info-list registered-list left mb25 rs100">
    <li><h4>${_regprocessing}</h4></li>
    </ul>
    <div class="right rs100">
      <a class="btn-main btn-lg ${upp_assets.buttons.secondary_btn}  ml25">${_regbuy} <span class="fas fa-chevron-right"></span></a>
     </div>
  </div>`;

var regHTML = `
    <div class="registered-summary clearfix clear mt30rs" style="display:none">
    <div class="clear lbreak3 op50"></div>
    <ul class="info-list registered-list left mb25 rs100">
      <li><strong>${_regaccepted} <span class="regdate" data-field="regdate"></span> &nbsp;&nbsp; <span class="regcode2" data-field="regcode2"></span></strong></li>
      <li><span class="regnotice">${_regaccepted2}</span></li>
    </ul>
    <div class="right rs100">
      <a class="btn-main btn-lg ${upp_assets.buttons.secondary_btn} ml25 disabled">${_rbtnsoon}</a>
     </div>
  </div>`;

var regHTMLsale = `
    <div class="registered-summary clearfix clear mt30rs" style="display:none">
    <div class="clear lbreak3 op50"></div>
    <ul class="info-list registered-list left mb25 rs100">
      <li><strong>${_regaccepted} <span class="regdate" data-field="regdate"></span></strong></li>
      <li><span>${_regaccepted2}</span></li>
    </ul>
    <div class="right rs100">
      <a class="btn-main btn-lg mt25rs rs100 ${upp_assets.buttons.secondary_btn} ml25">${_regbuy} <span class="fas fa-chevron-right"></span></a>
     </div>
  </div>`;


var registrationModal = `
    <div id="registration-confirm" class="modal" style="display: none">
      <div class="md-content">
        <div class="inner content ">
          <div class="replacer w880">
            <div class="register-text" style="display: none">
              <h1>${_regtext1}</h1>
              <div class="lbreak3 op50"></div>
              <p>${_regtext2} <strong class="regtitle"></strong> </p>
              <ul id="confirm-info" class="confirm-list info-list">
                <li><span>${_fullname}:</span> <strong data-field="firstname"></strong> <strong data-field="lastname"></strong></li>
                <li><span>${_email}:</span> <strong data-field="email"></strong></li>
                <li><span>${_birthday}:</span> <strong data-field="birthday"></strong></li>
                <li><span>${_location}:</span> <strong data-field="country"></strong></li>
                <li><span>${_gender}:</span> <strong data-field="gender"></strong></li>
                <li><span>${_homeevent}:</span> <strong data-field="homeevent"></strong></li>
              </ul>
              <div class="clear rs100 mb50">
              <p>${_agreeregister}</p>
              </div>
              <div class="actions">
              <a href="${upp_page.edit}" class="btn-main mb25 btn-lg ${upp_assets.buttons.outline_btn} mr25">${_updateinfobtn} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
            <div class="guest-text" style="display: none">
              ${passportimage}
              <div class="lbreak3 clear op50"></div>
              <h1  style="font-size:24px">${_regguest1}</h1>
              <p class="mb50">${_agreeregister}</p>
              <div class="actions"">
                <a href="${upp_page.signup}" class="btn-main mb25 signupbtn ${upp_assets.buttons.primary_btn} btn-lg mr25">${_signuptext} <span class="fas fa-chevron-right"></span></a> <a class="btn-main ${upp_assets.buttons.outline_btn} btn-lg loginbtn" href="${upp_page.login}">${_logintext} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
            <div class="pending-text" style="display: none">
              ${passportimage}
              <div class="lbreak3 clear op50"></div>
              <h1>${_regpending1}</h1>
              <p>${_regpending2}</p>
              <div class="actions">
              <a href="${upp_page.dashboard}" class="btn-main ${upp_assets.buttons.primary_btn} btn-lg btn-resend mr25">${_resendverify} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
            <div class="types-text" style="display: none">
              <h1>${_selectregtype}</h1>
              <div class="lbreak3 clear op50"></div>
              <div class="actions types padt20">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-bg"></div>
      <a class="md-close"><i></i><b></b></a>
    </div>`;

var waitlistModal = `
    <div id="waitlist-confirm" class="modal" style="display: none">
      <div class="md-content">
        <div class="inner content ">
          <div class="replacer w880">
            <div class="guest-text" style="display: none">
              ${passportimage}
              <div class="lbreak3 clear op50"></div>
              <h1  style="font-size:24px">${_waitlistguest1}</h1>
              <p class="mb50">${_agreewaitlist}</p>
              <div class="actions"">
                <a href="${upp_page.signup}" class="btn-main mb25 signupbtn ${upp_assets.buttons.primary_btn} btn-lg mr25">${_signuptext} <span class="fas fa-chevron-right"></span></a>
                <a class="btn-main ${upp_assets.buttons.outline_btn} btn-lg loginbtn" href="${upp_page.login}">${_logintext} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
            <div class="pending-text" style="display: none">
              ${passportimage}
              <div class="lbreak3 clear op50"></div>
              <h1>${_regpending1}</h1>
              <p>${_waitlistpending2}</p>
              <div class="actions">
                <a href="${upp_page.dashboard}" class="btn-main ${upp_assets.buttons.primary_btn} btn-lg btn-resend mr25">${_resendverify} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
            <div class="types-text" style="display: none">
              <h1>${_selectregtype}</h1>
              <div class="lbreak3 clear op50"></div>
              <div class="actions types padt20">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-bg"></div>
      <a class="md-close"><i></i><b></b></a>
    </div>`;

var updatesModal = `
    <div id="updates-guest" class="modal" style="display: none">
      <div class="md-content">
        <div class="inner content">
          <div class="replacer w880">
            <div class="guest-text">
              ${passportimage}
              <div class="lbreak3 clear op50"></div>
              <h1 style="font-size:24px">${_updatestext1}</h1>
              <p class="mb50">${_agreesignup2}</p>
              <div class="guest-actions">
                <a style="display:none;" href="${upp_page.dashboard}" class="btn-main pending-text ${upp_assets.buttons.primary_btn} btn-lg btn-resend mr25">${_resendverify} <span class="fas fa-chevron-right"></span></a>
                <a href="${upp_page.signup}" class="btn-main mb25 signupbtn guest-text ${upp_assets.buttons.primary_btn} btn-lg mr25">${_signuptext} <span class="fas fa-chevron-right"></span></a>
                <a class="btn-main ${upp_assets.buttons.outline_btn} btn-lg guest-text loginbtn" href="${upp_page.login} ">${_logintext} <span class="fas fa-chevron-right"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-bg"></div>
      <a class="md-close"><i></i><b></b></a>
    </div>`;


var ppdashnav = `
  <li><a href="#dashboard" class="active" data-title="${_mypassport}">${_btn_dashboard}</a></li>
  <li><a href="#benefits"data-title="${_btn_benefits}">${_btn_benefits}</a></li>
  <li><a href="#qualify" data-title="${_howtoqualify}">${_btn_qualify}</a></li>
  <li><a href="#points" data-title="${_btn_points}">${_btn_points}</a></li>`;
